import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'Pods/Shared/Tooltip'
import StarsRating from 'Pods/Shared/StarsRating'
import Icon from 'Pods/Shared/Icon/Icon'
import ContactModal from 'Pods/Shared/ContactModal'
import UserSidebarAction from 'Pods/Shared/UserSidebarAction'

import RatingTooltip from './UserInfoRatingTooltip'
import UserInfoStats from './UserInfoStats'
import UserInfoSectionHeader from './UserInfoSectionHeader'

class UserInfoSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      contactModalIsOpen: false,
      isInvited: this.props.isInvited,
      processingData: false,
    }

    this.toggleModal = this.toggleModal.bind(this)
    this.handleLocationClick = this.handleLocationClick.bind(this)
    this.onInviteClick = this.onInviteClick.bind(this)
    this.onInviteClickSuccess = this.onInviteClickSuccess.bind(this)
    this.onInviteClickFailure = this.onInviteClickFailure.bind(this)
  }

  handleLocationClick(location) {
    this.props.handleLocationClick({
      ...this.props.filters,
      keywords: location,
      searchFilter: 'location',
    })
  }

  toggleModal() {
    if (App.config.userSignedIn) {
      this.setState({ contactModalIsOpen: !this.state.contactModalIsOpen })
    } else {
      App.events.publish('app:login:open')
    }
  }

  onInviteClick() {
    this.setState({ processingData: true })

    axios.post(`/api/internal/jobs/${this.props.jobId}/invite`, {
      data: { attributes: { designer: this.props.userId } },
    }).then(this.onInviteClickSuccess).catch(this.onInviteClickFailure)
  }

  onInviteClickSuccess() {
    this.setState({
      isInvited: true,
      processingData: false,
    })

    App.events.publish('app:notification:flash:success', 'The invitation was successfully sent')
  }

  onInviteClickFailure() {
    this.setState({ processingData: false })

    App.events.publish('app:notification:flash:error', 'Error')
  }

  render() {
    const actions = [{
      active: this.props.userInfo.openForHire,
      icon: 'dollar-sign',
      path: `/3d-modeling-jobs/new/hire-designer/${this.props.userInfo.username}?meta_source=designer_index`,
      style: 'primary',
      title: 'Hire me',
      type: 'url',
    }, {
      active: true,
      icon: 'comment',
      style: 'secondary',
      title: 'Contact',
      type: 'modal',
    }]

    return (
      <aside>
        <section className="user-data user-data--user-info">
          <div className="user-data__section user-data__section--top l-inner">
            <UserInfoSectionHeader
              userInfo={this.props.userInfo}
              handleLocationClick={this.handleLocationClick}
            />
            <div>
              <Tooltip
                id={`user-ratings__tooltip-${this.props.userInfo.username}`}
                content={<RatingTooltip userRatings={this.props.totals.ratings} />}
                place="bottom"
                wrapperClassName="user-info__tooltip-wrapper"
              >
                <div className="user-data__rating-row">
                  <span className="user-data__rating-wrapper">
                    <StarsRating rating={this.props.userInfo.rating} readonly />
                  </span>
                  <span className="user-data__rating-wrapper heading-14">
                    {this.props.totals.ratings.model.count + this.props.totals.ratings.project.count}
                  </span>
                  <span className="user-data__icon-wrapper heading-12">
                    <Icon type={['far', 'chevron-down']} notSpaced />
                  </span>
                </div>
              </Tooltip>
            </div>
            <UserInfoStats
              username={this.props.userInfo.username}
              totals={this.props.totals}
            />
            {this.state.contactModalIsOpen && (
              <ContactModal
                modalIsOpen
                closeModal={this.toggleModal}
                authorUsername={this.props.userInfo.username}
                conversationType="personal"
                messagingForbidden={this.props.messagingForbidden}
              />
            )}
            {actions && (
              <Fragment>
                {this.props.inviteDesignersPage ? (
                  <button
                    className="btn btn-primary button--longer"
                    disabled={this.state.isInvited || this.state.processingData}
                    onClick={this.onInviteClick}
                  >
                    {this.state.isInvited ? 'Invited' : 'Invite'}
                  </button>
                ) : (
                  <div className="user-data__actions">
                    {actions.map((action) => (
                      <UserSidebarAction
                        key={`action-${action.title}`}
                        action={action}
                        openModal={this.toggleModal}
                        id={this.props.userInfo.username}
                      />
                    ))}
                  </div>
                )}
              </Fragment>
            )}
          </div>
        </section>
      </aside>
    )
  }
}

UserInfoSection.propTypes = {
  userInfo: PropTypes.object.isRequired,
  totals: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  messagingForbidden: PropTypes.bool,
}

export default UserInfoSection
